import React from "react";
import { Link } from "@components";
import PropTypes from "prop-types";
import cx from "classnames";

const Sidebar = ({ className, current }) => {
  const getCurrentClass = (name) =>
    cx(
      "group flex items-center px-2 py-2 text-sm leading-5  text-blue-gray-600 rounded-md whitespace-no-wrap hover:text-blue-gray-900 hover:bg-gray-200 focus:outline-none focus:text-blue-gray-900 focus:bg-gray-50 transition ease-in-out duration-150",
      { "bg-gray-200": current === name }
    );
  return (
    <div className={cx("flex flex-col w-64 lg:mr-16", className)}>
      <div className="flex flex-col flex-grow lg:pb-4 overflow-y-auto">
        <div className="flex flex-col">
          <nav className="flex-1">
            <Link to="/dashboard" className={getCurrentClass("dashboard")}>
              <svg
                className="mr-3 h-6 w-6 text-blue-gray-500 group-hover:text-blue-gray-500 group-focus:text-blue-gray-600 transition ease-in-out duration-150 flex-shrink-0"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 21V23H11V21H3C2.44772 21 2 20.5523 2 20V6H22V20C22 20.5523 21.5523 21 21 21H13Z"
                  fill="#515669"
                />
                <path d="M4 19H20V8H4V19Z" fill="white" />
                <path d="M13 10H18V12H13V10Z" fill="#515669" />
                <path d="M13 14H18V16H13V14Z" fill="#515669" />
                <path
                  d="M9 10V13H12C12 14.6569 10.6569 16 9 16C7.34315 16 6 14.6569 6 13C6 11.3431 7.34315 10 9 10Z"
                  fill="#515669"
                />
                <path d="M2 3H22V5H2V3Z" fill="#515669" />
              </svg>
              My Account
            </Link>
            <hr className="h-px my-4 lg:my-8 bg-gray-200 border-none" />
            <div className="">
              <div className="px-2 py-2 text-xxs leading-4 font-semibold text-blue-gray-500 uppercase ">
                SALES
              </div>
              <div
                className="mt-1 space-y-1"
                role="group"
                aria-labelledby="teams-headline"
              >
                <Link to="/listings" className={getCurrentClass("listings")}>
                  <span className="truncate">My Listings</span>
                </Link>
              </div>
              <div
                className="mt-1 space-y-1"
                role="group"
                aria-labelledby="teams-headline"
              >
                <Link
                  to="/orders?type=sales"
                  className={getCurrentClass("sales")}
                >
                  <span className="truncate">Sales Orders</span>
                </Link>
              </div>
            </div>
            <hr className="h-px my-4 lg:my-8 bg-gray-200 border-none" />
            <div className="">
              <div className="px-2 py-2 text-xxs leading-4 font-semibold text-blue-gray-500 uppercase ">
                PURCHASES
              </div>
              <div
                className="mt-1 space-y-1"
                role="group"
                aria-labelledby="teams-headline"
              >
                <Link
                  to="/bids"
                  className={getCurrentClass("bids")}
                >
                  <span className="truncate">My Bids</span>
                </Link>

                <Link
                  to="/orders?type=purchase"
                  className={getCurrentClass("purchase")}
                >
                  <span className="truncate">Purchase Orders</span>
                </Link>
              </div>
            </div>
            <hr className="h-px my-4 lg:my-8 bg-gray-200 border-none" />
            <div className="space-y-2">
              <Link to="/statements" className={getCurrentClass("statements")}>
                <svg
                  className="mr-3 h-6 w-6 text-blue-gray-400 group-hover:text-blue-gray-500 group-focus:text-blue-gray-500 transition ease-in-out duration-150 flex-shrink-0"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 6.00012V3.00012C7 2.44784 7.44772 2.00012 8 2.00012H20C20.5523 2.00012 21 2.44784 21 3.00012V17.0001C21 17.5524 20.5523 18.0001 20 18.0001H17V21.0001C17 21.5521 16.55 22.0001 15.993 22.0001H4.007C3.74065 22.0017 3.48465 21.8971 3.29566 21.7094C3.10666 21.5217 3.00026 21.2665 3 21.0001L3.003 7.00012C3.003 6.44812 3.453 6.00012 4.009 6.00012H7ZM5.002 8.00012L5 20.0001H15V8.00012H5.002ZM17 6.00012H9V4.00012H19V16.0001H17V6.00012ZM7 11.0001H13V13.0001H7V11.0001ZM13 15.0001H7V17.0001H13V15.0001Z"
                    fill="#555555"
                  />
                </svg>
                Tax Statements
              </Link>
              <Link to="/wallet" className={getCurrentClass("wallet")}>
                <svg
                  className="mr-3 h-6 w-6 text-blue-gray-400 group-hover:text-blue-gray-500 group-focus:text-blue-gray-500 transition ease-in-out duration-150 flex-shrink-0"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23 7H22V4C22 3.44772 21.5523 3 21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V17H23V7ZM9 12C9 14.7614 11.2386 17 14 17H20V19H4V5H20V7H14C11.2386 7 9 9.23858 9 12ZM21 15V9H14C12.3431 9 11 10.3431 11 12C11 13.6569 12.3431 15 14 15H21ZM17 11H14V13H17V11Z"
                    fill="#555555"
                  />
                </svg>
                My Wallet
              </Link>
              <Link to="/setting" className={getCurrentClass("setting")}>
                <svg
                  className="mr-3 h-6 w-6 text-blue-gray-400 group-hover:text-blue-gray-500 group-focus:text-blue-gray-500 transition ease-in-out duration-150 flex-shrink-0"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.316 9.49618C2.11 10.2972 2 11.1352 2 12.0002C2 12.8662 2.11 13.7042 2.315 14.5032C3.44199 14.4433 4.50723 15.021 5.07181 15.9982C5.6364 16.9754 5.60478 18.1868 4.99 19.1332C6.19894 20.3226 7.69079 21.1847 9.325 21.6382C9.83678 20.632 10.8701 19.9982 11.999 19.9982C13.1279 19.9982 14.1612 20.632 14.673 21.6382C16.3072 21.1847 17.7991 20.3226 19.008 19.1332C18.3938 18.1868 18.3625 16.9758 18.927 15.999C19.4915 15.0221 20.5563 14.4446 21.683 14.5042C21.889 13.7032 21.999 12.8652 21.999 12.0002C21.999 11.1352 21.889 10.2972 21.683 9.49718C20.556 9.55707 19.4908 8.9794 18.9262 8.0022C18.3616 7.02499 18.3932 5.81361 19.008 4.86718C17.7991 3.67775 16.3072 2.81568 14.673 2.36218C14.1612 3.3684 13.1279 4.00214 11.999 4.00214C10.8701 4.00214 9.83678 3.3684 9.325 2.36218C7.69079 2.81568 6.19894 3.67775 4.99 4.86718C5.60408 5.81342 5.63545 7.02415 5.07121 8.00093C4.50696 8.9777 3.44248 9.5554 2.316 9.49618ZM7.368 18.5242C7.614 17.3462 7.434 16.0912 6.804 15.0002H6.805C6.19013 13.9344 5.20335 13.1331 4.034 12.7502C3.98775 12.2513 3.98775 11.7491 4.034 11.2502C5.20298 10.867 6.18937 10.0658 6.804 9.00018C7.41972 7.93511 7.62056 6.68022 7.368 5.47618C7.77589 5.18611 8.21013 4.93501 8.665 4.72618C9.58167 5.54735 10.7693 6.00104 12 6.00018C13.2303 6.00079 14.4176 5.54712 15.334 4.72618C15.7889 4.935 16.2231 5.18611 16.631 5.47618C16.3784 6.68022 16.5793 7.93511 17.195 9.00018C17.8099 10.066 18.7966 10.8672 19.966 11.2502C20.0122 11.7491 20.0122 12.2513 19.966 12.7502C18.797 13.1333 17.8106 13.9346 17.196 15.0002C16.5803 16.0653 16.3794 17.3201 16.632 18.5242C16.224 18.8142 15.79 19.0652 15.335 19.2742C14.438 18.4712 13.26 18.0002 12 18.0002C10.7693 17.9993 9.58167 18.453 8.665 19.2742C8.21 19.0652 7.776 18.8142 7.368 18.5242ZM12 15.0002C10.3431 15.0002 9 13.657 9 12.0002C9 10.3433 10.3431 9.00018 12 9.00018C13.6569 9.00018 15 10.3433 15 12.0002C15 13.657 13.6569 15.0002 12 15.0002ZM13 12.0002C13 12.5525 12.5523 13.0002 12 13.0002C11.4477 13.0002 11 12.5525 11 12.0002C11 11.4479 11.4477 11.0002 12 11.0002C12.5523 11.0002 13 11.4479 13 12.0002Z"
                    fill="#555555"
                  />
                </svg>
                Settings
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  current: PropTypes.string,
};

export default Sidebar;
